import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon-types';

export type CheckIconProps = IconProps;

export const CheckIcon: FC<CheckIconProps> = ({ className, iconColor = '#EAECF0', ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="11"
    viewBox="0 0 15 11"
    width="15"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1667 1L4.99999 10.1667L0.833328 6"
      stroke={iconColor}
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.66667"
    />
  </svg>
);
